import { Layers, Radar, ShieldCheck, Clock, ReceiptText } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PROPS = [
  {
    icon: Layers,
    title: "Reliable capacity & coverage",
    body: "Trucks and trailers available across major industrial corridors, when you need them.",
  },
  {
    icon: Radar,
    title: "GPS / real-time tracking",
    body: "Every consignment visible end to end. You always know where your freight is.",
  },
  {
    icon: ShieldCheck,
    title: "Safety & compliance",
    body: "Checked vehicles, verified documentation, and loads secured to spec — every trip.",
  },
  {
    icon: Clock,
    title: "On-time delivery discipline",
    body: "Dispatch windows are commitments, not estimates. Delays are flagged before you ask.",
  },
  {
    icon: ReceiptText,
    title: "Transparent billing",
    body: "Quoted, documented, invoiced. No surprises after delivery.",
  },
];

export const WhyAgaman = () => (
  <section id="why" data-testid="why-section" className="scroll-mt-20 py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead
        overline="Why Agaman"
        title="Five reasons shippers stay."
      />

      <div className="mt-14 border-t border-slate-800">
        {PROPS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div
              data-testid={`why-item-${i + 1}`}
              className="group grid sm:grid-cols-[64px_64px_1fr] items-start gap-4 sm:gap-8 py-8 border-b border-slate-800 hover:bg-[#161B22]/60 transition-colors duration-300 px-2 sm:px-4"
            >
              <span className="mono text-lg font-semibold text-slate-700 group-hover:text-amber-500 transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="w-11 h-11 flex items-center justify-center border border-slate-700 group-hover:border-amber-500 transition-colors duration-300">
                <p.icon className="w-5 h-5 text-amber-500" />
              </span>
              <div>
                <h3 className="font-display text-lg sm:text-xl font-bold uppercase tracking-wide text-slate-100">
                  {p.title}
                </h3>
                <p className="mt-2 text-base text-slate-400 leading-relaxed max-w-2xl">
                  {p.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
